// This file is generated.
export var version = '1.60.0';
//# sourceMappingURL=version.js.map